function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.33422 23.1111C1.66882 23.1111 1.11367 22.8887 0.668778 22.4438C0.223889 21.9989 0.000962963 21.4433 0 20.7769V2.33422C0 1.66881 0.222926 1.11367 0.668778 0.668777C1.11463 0.223889 1.6693 0.000962963 2.33278 0H23.6672C24.3317 0 24.8863 0.222926 25.3312 0.668777C25.7761 1.11463 25.999 1.66978 26 2.33422V20.7783C26 21.4428 25.7771 21.9979 25.3312 22.4438C24.8854 22.8896 24.3307 23.1121 23.6672 23.1111H2.33422ZM2.33422 21.6667H23.6672C23.8887 21.6667 24.0924 21.5742 24.2782 21.3893C24.4641 21.2044 24.5565 21.0003 24.5556 20.7769V2.33422C24.5556 2.11178 24.4631 1.90763 24.2782 1.72178C24.0933 1.53593 23.8897 1.44348 23.6672 1.44444H2.33278C2.1113 1.44444 1.90763 1.53689 1.72178 1.72178C1.53593 1.90667 1.44348 2.11081 1.44444 2.33422V20.7783C1.44444 20.9998 1.53689 21.2035 1.72178 21.3893C1.90667 21.5752 2.11033 21.6676 2.33278 21.6667",
  fill: "#343953"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.14887 18.2949H3.37109V16.8505H9.14887V18.2949Z",
  fill: "#3D55DC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5649 8.97826L16.4433 15.1013L13.3912 12.0477L14.385 11.0178L16.4433 13.0747L21.535 7.94692L22.5649 8.97826Z",
  fill: "#3D55DC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.14887 12.5171H3.37109V11.0727H9.14887V12.5171Z",
  fill: "#3D55DC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.14887 6.73937H3.37109V5.29492H9.14887V6.73937Z",
  fill: "#3D55DC"
});

function SvgChecklistmenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.2,
    height: 28.8,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistmenu);
export default __webpack_public_path__ + "static/media/checklistmenu.cb9651aa.svg";
export { ForwardRef as ReactComponent };